import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { type UseModalState } from "@src/lib/ui-react";

interface MappingFailedDialogProps {
  modalState: UseModalState;
  isSubmitting: boolean;
  errorMessage: string;
  onRetry: () => void;
}

export function MappingFailedDialog(props: MappingFailedDialogProps) {
  const { modalState, isSubmitting, errorMessage, onRetry } = props;

  return (
    <Dialog fullWidth maxWidth="sm" open={modalState.modalIsOpen} onClose={modalState.closeModal}>
      <DialogTitle>Requirement Mapping Failed</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ marginTop: 1 }}>
          <Alert severity="success">1099 Policy entity was created successfully.</Alert>
          <Alert severity="error">{errorMessage}</Alert>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={isSubmitting} onClick={modalState.closeModal}>
          Close
        </Button>
        <Button variant="contained" color="primary" disabled={isSubmitting} onClick={onRetry}>
          {isSubmitting ? <CircularProgress size={24} /> : "Retry Mapping"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
